<mg-ui-loading-container [isLoading]="isLoading">
    <mg-pdfobject
        *ngIf="dealContractPdf$ | async as dealContractPdf"
        [src]="dealContractPdf.url"
        (proceedButtonClick)="handleProceedButtonClick()"
        [proceedButtonText]="proceedButtonText"
        [downloadButtonText]="downloadButtonText"
        [viewButtonText]="viewButtonText"
    ></mg-pdfobject>
</mg-ui-loading-container>
